export const STEP3_SUBMIT_REQUEST = "STEP3_SUBMIT_REQUEST";
export const STEP3_SUBMIT_SUCCESS = "STEP3_SUBMIT_SUCCESS";
export const STEP3_SUBMIT_FAILED = "STEP3_SUBMIT_FAILED";

export const CLEAR_STEP3_FORM_SUCCESS = "CLEAR_STEP3_FORM_SUCCESS";
